export function getDefaultSignParams() {
    return {
        _username: '',
        _password: '',
        approve_age: false
    };
}